import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, TrendingUp, Clock, Users } from "lucide-react";

export default function FinancialReportsPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="financial-reports-page">
      <div className="mb-6"><h1 className="font-heading font-bold text-2xl text-[#1F2937]">Financial Reports</h1>
        <p className="text-sm text-gray-500 mt-1">Aging reports, statements, and financial summaries</p></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="border rounded-sm cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate("/aging-reports")}>
          <CardContent className="p-5"><div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3 text-amber-600 bg-amber-50"><Clock className="w-5 h-5" /></div>
            <h3 className="font-semibold text-[#1F2937]">Aging Reports</h3><p className="text-xs text-gray-500 mt-1">30/60/90 day debtor and creditor aging analysis</p>
            <Button size="sm" className="mt-3 bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm">View Aging</Button></CardContent></Card>
        <Card className="border rounded-sm cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate("/statements")}>
          <CardContent className="p-5"><div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3 text-blue-600 bg-blue-50"><Users className="w-5 h-5" /></div>
            <h3 className="font-semibold text-[#1F2937]">Account Statements</h3><p className="text-xs text-gray-500 mt-1">Customer and supplier account statements with running balance</p>
            <Button size="sm" className="mt-3 bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm">View Statements</Button></CardContent></Card>
      </div>
    </div>
  );
}
